import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { PersonSearchStorageVM } from 'shell/view-models/search-anpr';
import { useFilterTable } from 'shell/hooks/use-filter-table';

const ActionsList = ({ cell, filterPersonForm }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();
  const personFilterTable = useFilterTable<PersonSearchStorageVM>();
  const onVisibilityPress = useEventCallback(() => {
    return new Promise((resolve) => {
      personFilterTable.setValues({
        filters: filterPersonForm,
        subject: cell,
      });

      navigate({
        pathname: '/sportello/autorizzazione-voto/stampa',
        search: `?${createSearchParams({
          ricercaNazionale:
            filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
            filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
            'false',
          codiceFiscale: cell?.fiscalCode || '',
          idSchedaSoggettoANPR: cell?.anpr || '',
          idFamigliaANPR: cell?.idFamilyAnpr || '',
          idSchedaSoggettoComune: cell?.idSchedaSoggettoComune?.idSchedaSoggetto || '',
          codicePersonaSipo: cell?.codicePersonaSipo || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onVisibilityPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <VisibilityIcon />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Authorization vote search Persons page component';

export default ActionsList;
